import Database from "~/lib/Database";

// Fetches the given resource and parses it through the Database parser.
const fetcher = <T>(
  input: RequestInfo | URL,
  camelizeResponse = true,
  init: Partial<RequestInit> & { signal: AbortSignal },
): Promise<T> => {
  return fetch(input, init)
    .then((res) => {
      if (!res.ok) {
        throw new Error(res.statusText || "Failed to fetch resource");
      }

      return res.json();
    })
    .then((json) => {
      if (!camelizeResponse) {
        return json;
      }

      return Database.parse(json);
    });
};

export default fetcher;
